import { fetchCommentary, fetchMatchStats } from "@/helpers/Opta";

/**
 * Data de la página de partido: minuto a minuto + detalle del partido.
 * Las claves son los props que espera el componente MatchPage.
 */
export const loadMatchPage = async ({ matchId }) => {
    if (!matchId) return {};

    const [commentary, matchStats] = await Promise.all([
        fetchCommentary({ matchId }),
        fetchMatchStats({ matchId }),
    ]);

    return {
        matchData: commentary ?? [],
        matchDetail: matchStats ?? [],
    };
};
